import React from 'react';
import LiteForm from './LiteForm';

class LiteCreate extends React.Component {

    render(){
        return (
            <div>
                <LiteForm />
            </div>
        );
    }

}
export default LiteCreate;



// WEBPACK FOOTER //
// ./src/pages/LiteScenes/LiteCreate.js